import {
  type CreateCheckoutSessionRequestType,
  type CreateCheckoutSessionResponseType,
  type GetInvoicesResponseType,
  type GetLicensesQueryType,
  type GetLicensesResponseType,
  type GetUpgradeablePackagesResponseType,
} from '@/services/api/premium/types'
import { type PremiumFeaturesReturnProps } from '@/services/types/premiumFeatures/premiumFeatures'
import { api, v2BaseURL } from '../api'
import { endpoints } from '../endpoints'

export const premiumService = {
  getFeatures: async () =>
    api.get<PremiumFeaturesReturnProps>(endpoints.premium.getFeatures, {
      baseURL: v2BaseURL,
    }),

  getLicenses: async (props: GetLicensesQueryType) =>
    api.get<GetLicensesResponseType>(endpoints.premium.getLicenses, {
      params: props,
      baseURL: v2BaseURL,
    }),

  getInvoices: async (licenseId: string) =>
    api.get<GetInvoicesResponseType>(
      endpoints.premium.getInvoices.replace(':licenseId', licenseId),
      {
        baseURL: v2BaseURL,
      },
    ),

  getUpgradeablePackages: async () =>
    api.get<GetUpgradeablePackagesResponseType>(endpoints.premium.getUpgradeablePackages, {
      baseURL: v2BaseURL,
    }),

  createCheckoutSession: async (data: CreateCheckoutSessionRequestType) => {
    const { insertCoupon, ...rest } = data
    return api.post<CreateCheckoutSessionResponseType>(
      endpoints.premium.createCheckoutSession,
      rest,
      {
        baseURL: v2BaseURL,
        params: insertCoupon ? { insertCoupon: true } : undefined,
      },
    )
  },
}
